export default {
  banner: {
    documentAlt: 'Document Icon',
    stepsToPrepare: 'Two easy steps to prepare for tax season',
    submitYourInfo: 'Submit your tax information',
    request1099: 'Request Form 1099-K',
    step1Alt: 'Step 1',
    step2Alt: 'Step 2',
    explanationHtml: 'If you sell more than $600 in a calendar year, your tax info is needed so we can issue you a Form 1099-K. {{children}}',
  },
  footer: {
    speakerAlt: 'Speaker Icon',
    shieldAlt: 'Shield Icon',
    whyThisChangeHeader: 'Why this change?',
    whyThisChangeParagraph1: 'As of January 1, 2022, marketplaces like Reverb are required to collect tax identification information from US sellers who sell $600 or more in a calendar year. This info is needed to issue you a Form 1099-K. If you hit the threshold and don\'t provide this information, your payouts will temporarily be put on hold until you enter your tax information.',
    whyThisChangeParagraph2: 'Once you\'ve provided your tax information, we’ll reach out to you on any next steps—including when your Form 1099-K is ready to download. Note that reporting your sales doesn\'t necessarily mean you\'ll need to pay income tax on your sales. {{children}}',
    advocacyHeadline: 'How we’re advocating for change in this law',
    advocacyParagraph1: 'We\'re urgently working to get Congress to change this law and prevent millions of Americans from sorting through confusing tax documents. Our goal is to educate policy makers on the benefits of reselling music gear online and the negative impact this new threshold has on many music makers. {{children}}',
    advocacyLearnMore: 'You can learn more here.',
    advocacyParagraph2: 'Want to help us advocate for a change in this law? {{children}} saying 1099-K reform is needed. After clicking the "Send a Letter" button and entering a few details, a completed letter will be sent directly to your local member of Congress.',
    advocacySendALetter: 'Send a letter to Congress',
  },
  taxForms: {
    comingSoon: 'Coming soon: if you sold more than $600 in 2022, your Form 1099-K will be available here at the end of January {{year}}.',
    noFormsAvailable: 'You currently have no tax forms available.',
    downloadTaxForm: 'Download your Form 1099-K',
    failure: 'Something went wrong downloading your tax form.  Please try again.',
    loading: 'Loading your Form 1099-K.',
    requestDownload: 'Request {{children}} Form 1099-K',
    requested: 'Form 1099-K successfully requested! A download link to your Form 1099-K will be available below shortly.',
    secureDownload: 'For your security, this link will expire after 24 hours.',
    title: 'Request Form 1099-K',
    description: 'If you prefer a paper Form 1099-K mailed to you, please email {{children}}.',
    emailLinkText: '1099taxreporting@reverb.com',
    downloadIncompleteStatus: 'Incomplete',
    downloadRequestedStatus: 'Last requested on {{date}}',
  },
  taxInformationNeededBanner: {
    headline: '2022 tax information needed',
    submitButtonText: 'Submit my tax info',
    informationNeeded: 'Please provide your tax information so that you can continue receiving payouts.',
  },
  helpCenterLinkText: 'Learn more in our Help Center.',
};
